import React, { useState } from "react";
import "./DiscoverMorePage.css";
import offeringsintro from "../../assets/utility_images/offerings.jpeg";
import { Container } from "react-bootstrap";
import arrowRight from "../../assets/utility_images/arrow-right.svg";
import { Link as ScrollLink } from "react-scroll";
import { useParams } from "react-router-dom";
import { useLanguage } from "../../Context/LanguageContext";
import { useQuery } from "@tanstack/react-query";
import Loader from "../../components/Loader/Loader";
import fallbackDataCloudComputingEN from "../../FallbackAPI/CloudComputingLocal/FallbackApiCloudComputingEN.json";
import fallbackDataCloudComputingKR from "../../FallbackAPI/CloudComputingLocal/FallbackApiCloudComputingKR.json";
import fallbackDataBigDataEN from "../../FallbackAPI/BigDataLocal/FallbackApiBigDataEN.json";
import fallbackDataBigDataKR from "../../FallbackAPI/BigDataLocal/FallbackApiBigDataKR.json";
import fallbackDataEmbeddedSystemsEN from "../../FallbackAPI/EmbeddedSystemsLocal/FallbackApiEmbeddedSystemsEN.json";
import fallbackDataEmbeddedSystemsKR from "../../FallbackAPI/EmbeddedSystemsLocal/FallbackApiEmbeddedSystemsKR.json";
import fallbackDataSoftwareEngineeringEN from "../../FallbackAPI/SoftwareEngineeringLocal/FallbackApiSoftwareEngineeringEN.json";
import fallbackDataSoftwareEngineeringKR from "../../FallbackAPI/SoftwareEngineeringLocal/FallbackApiSoftwareEngineeringKR.json";

const DiscoverMorePage = () => {
  const { cardName } = useParams();
  const { language } = useLanguage();
  const baseUrl = process.env.REACT_APP_API_BASE_URL;

  //  get fallback data according to card name
  const getFallbackData = () => {
    switch (cardName) {
      case "cloudcomputing":
        return language === "en"
          ? fallbackDataCloudComputingEN
          : fallbackDataCloudComputingKR;
      case "bigdata":
        return language === "en"
          ? fallbackDataBigDataEN
          : fallbackDataBigDataKR;
      case "embeddedsystems":
        return language === "en"
          ? fallbackDataEmbeddedSystemsEN
          : fallbackDataEmbeddedSystemsKR;
      case "softwareengineering":
        return language === "en"
          ? fallbackDataSoftwareEngineeringEN
          : fallbackDataSoftwareEngineeringKR;
      default:
        console.warn(`No fallback data available for cardName: ${cardName}`);
        return {}; // Default to an empty object if cardName doesn't match
    }
  };

  const fetchDiscoverMoreData = async () => {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 1500); // 1.5s timeout

    try {
      const response = await fetch(`${baseUrl}/page/${cardName}/${language}`, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
        signal: controller.signal,
      });

      clearTimeout(timeout);
      if (!response.ok) {
        throw new Error("Failed to fetch job details");
      }
      return response.json();
    } catch (error) {
      console.warn("API request failed, using fallback data.");
      return getFallbackData(); // Return fallback data based on cardName
    }
  };

  const {
    data: CardApiData,
    isLoading,
    error,
  } = useQuery({
    queryKey: ["DiscoverMore", cardName, language],

    queryFn: fetchDiscoverMoreData,
    staleTime: 10 * 60 * 1000,
    cacheTime: 60 * 60 * 1000,
  });

  if (isLoading) {
    return <Loader />;
  }

  if (error) {
    return <div>Error loading data.</div>;
  }

  console.log(CardApiData);

  const renderSection = (section) => {
    switch (section.sectionName) {
      case "DiscoverMore":
        return (
          <Container fluid style={{ paddingLeft: 0, paddingRight: 0 }}>
            <section className="discover-more-section">
              <div className="discover-more">
                <div className="privacy-heading">{section.heading}</div>
                <div className="discover-description d-flex justify-content-center">
                  <div className="discover-text">
                    <ul>
                      {section.description
                        .split(".")
                        .map(
                          (sentence, index) =>
                            sentence.trim() && (
                              <li key={index}>{sentence.trim()}.</li>
                            )
                        )}
                    </ul>
                  </div>
                  <div className="discover-more-img">
                    <img src={section.imageUrl} alt="" loading="lazy" />
                  </div>
                </div>
              </div>
            </section>
          </Container>
        );

      default:
        return null;
    }
  };

  return (
    <div>
      {CardApiData.sections
        .filter((section) => section.isEnabled) // Filter sections
        .sort((a, b) => a.sectionOrder - b.sectionOrder) // Sort sections by sectionOrder
        .map((section) => renderSection(section))}
    </div>
  );
};

export default DiscoverMorePage;
